// Сетка выбора элементов — отдельно от диалога: тот теперь переключает два
// экрана (выбор и просмотр), и держать внутри него ещё и три состояния загрузки
// значило бы четыре уровня вложенных тернарников в одной разметке.

import type { TFunction } from "i18next";
import { Loader2 } from "lucide-react";

import type { Element } from "~/entities/element";

import { ElementPickerTile } from "./ElementPickerTile";

interface ElementPickerGridProps {
    t: TFunction;
    elements: readonly Element[];
    isLoading: boolean;
    /** Черновик выбора (ids) — до подтверждения диалога. */
    draft: readonly string[];
    maxElements: number;
    /** Что сказать при пустой выдаче: библиотека пуста или ничего не нашлось по запросу. */
    emptyText: string;
    onToggle: (elementId: string) => void;
    onView: (elementId: string) => void;
}

export function ElementPickerGrid({
    t,
    elements,
    isLoading,
    draft,
    maxElements,
    emptyText,
    onToggle,
    onView,
}: ElementPickerGridProps) {
    if (isLoading) {
        return (
            <div className="flex h-40 items-center justify-center text-muted-foreground">
                <Loader2 className="size-5 animate-spin" />
            </div>
        );
    }

    if (elements.length === 0) {
        return <p className="py-10 text-center text-sm text-muted-foreground">{emptyText}</p>;
    }

    return (
        <div className="grid max-h-[50vh] grid-cols-2 gap-3 overflow-y-auto md:grid-cols-4 sm:grid-cols-3">
            {elements.map((element) => {
                const selected = draft.includes(element.id);
                return (
                    <ElementPickerTile
                        key={element.id}
                        t={t}
                        element={element}
                        selected={selected}
                        limitReached={!selected && draft.length >= maxElements}
                        onToggle={onToggle}
                        onView={onView}
                    />
                );
            })}
        </div>
    );
}
